// extracted by mini-css-extract-plugin
module.exports = {"Experience":"Experience_Experience__32NDX","innerContainer":"Experience_innerContainer__RAD2i","bodyDiv":"Experience_bodyDiv__1Ctgr","duration":"Experience_duration__3mlnk"};